import * as React from "react";
import { JSX } from "react/jsx-runtime";
const PhoneIcon = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15.1875 19.0313C12.6563 19.0313 9.06251 17.2188 5.75001 14.0938C1.25001 9.78127 -0.656238 4.96878 1.34376 2.84378C1.43751 2.75003 1.56251 2.65628 1.68751 2.59378L4.21876 1.15627C4.87501 0.781275 5.68751 0.968775 6.12501 1.59377L7.96876 4.21877C8.18751 4.53127 8.28126 4.90627 8.18751 5.28127C8.12501 5.62502 7.90626 5.93753 7.59376 6.15628L6.50001 6.87502C7.34376 8.09377 9.62501 11.125 13.25 13.2813C13.2813 13.3125 13.3125 13.2813 13.3125 13.2813L14.0938 12.2188C14.5313 11.625 15.375 11.4688 16.0313 11.875L18.7813 13.625C19.4375 14.0313 19.625 14.875 19.2188 15.5313L17.7188 17.9375C17.625 18.0625 17.5313 18.1875 17.4375 18.2813C16.875 18.7813 16.0938 19.0313 15.1875 19.0313ZM4.93751 2.37502C4.90626 2.37502 4.93751 2.37502 4.93751 2.37502L2.37501 3.81252C1.18751 5.09377 2.65626 9.18752 6.75001 13.0625C10.9063 17 15.1875 18.4063 16.5625 17.2188L18.0625 14.8125L15.3125 13.0625C15.2813 13.0625 15.25 13.0625 15.25 13.0625L14.4688 14.125C14.0313 14.7188 13.1875 14.875 12.5625 14.5C8.65626 12.1563 6.21876 8.90627 5.34376 7.62502C5.12501 7.31252 5.06251 6.93753 5.12501 6.59377C5.18751 6.21877 5.40626 5.90627 5.71876 5.71877L6.81251 5.00002L5.00001 2.40627C4.96876 2.40627 4.93751 2.37502 4.93751 2.37502Z"
      fill="#004E9B"
    />
  </svg>
);
export default PhoneIcon;
